import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { CSSTransition } from 'react-transition-group';
import notebookGray from '@assets/notebook-gray.svg';
import notebookOrange from '@assets/notebook-orange.svg';
import { useStyles } from './styles';
import './styles.css';

const OrderCount = ({ result }) => {
  const classes = useStyles();
  const history = useHistory();
  const [isAnimate, setAnimate] = useState(false);
  const [isAnimateEmptyOrder, setAnimateEmptyOrder] = useState(false);

  useEffect(() => {
    if (result === 0) return setAnimateEmptyOrder(true);
    setAnimate(true);
  }, [result]);

  useEffect(() => {
    setAnimate(false);
    setAnimateEmptyOrder(false);
  }, []);

  return (
    <div className={classes.container}>
      {result > 0 ? (
        <CSSTransition
          in={isAnimate}
          timeout={200}
          classNames="animated-qty"
          onEntered={() => setAnimate(false)}
        >
          <button
            className={classes.orderButton}
            onClick={() => history.push('/orders-screen')}
          >
            <img
              className={classes.notebookImg}
              src={notebookOrange}
              alt="notebook"
            />

            <Typography variant="h6" className={classes.orderNumber}>
              {result}
            </Typography>
          </button>
        </CSSTransition>
      ) : (
        <CSSTransition
          in={isAnimateEmptyOrder}
          timeout={500}
          classNames="animated-qty-Empty"
        >
          <img
            className={classes.notebookImg}
            src={notebookGray}
            alt="notebook"
          />
        </CSSTransition>
      )}
    </div>
  );
};

export default OrderCount;
